module.exports = __webpack_public_path__ + "img/maestro-square.9d08ab01.svg";